import React from 'react';
import { BadgeAlt, DataTableColumnHeader, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, } from '@cargomatic/ui';
import { titleize } from 'underscore.string';
import { booleanFormatter, defaultFormatter, } from 'components/design-system/molecules/formatters';
import TariffTypes from '../TariffTypes';
const MARKETS_VISIBLE = 2;
function MarketsCell({ markets }) {
    if (!(markets === null || markets === void 0 ? void 0 : markets.length)) {
        return React.createElement("span", { className: "text-muted-foreground" }, '—');
    }
    const visible = markets.slice(0, MARKETS_VISIBLE);
    const overflow = markets.length - visible.length;
    return (React.createElement("div", { className: "flex flex-wrap items-center gap-1" },
        visible.map((m) => (React.createElement(BadgeAlt, { key: m, variant: "secondary" }, m))),
        overflow > 0 && (React.createElement(TooltipProvider, null,
            React.createElement(Tooltip, null,
                React.createElement(TooltipTrigger, { asChild: true },
                    React.createElement(BadgeAlt, { variant: "outline", className: "cursor-default" }, `+${overflow}`)),
                React.createElement(TooltipContent, null,
                    React.createElement("div", { className: "max-w-xs whitespace-normal" }, markets.join(', '))))))));
}
const TYPE_LABELS = TariffTypes.reduce((acc, tt) => {
    acc[tt.value] = tt.name;
    return acc;
}, {});
export function getTariffsColumns({ t, }) {
    return [
        {
            accessorKey: 'name',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: t('NAME') })),
            cell: ({ row }) => React.createElement("span", null, row.original.name),
            size: 220,
        },
        {
            accessorKey: 'type',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: t('TYPE') })),
            cell: ({ row }) => {
                var _a;
                return (React.createElement("span", null, (_a = TYPE_LABELS[row.original.type]) !== null && _a !== void 0 ? _a : defaultFormatter(row.original.type)));
            },
            size: 140,
        },
        {
            accessorKey: 'markets',
            header: () => React.createElement("span", null, titleize(t('MARKET', { count: 2 }))),
            cell: ({ row }) => React.createElement(MarketsCell, { markets: row.original.markets || [] }),
            enableSorting: false,
            size: 180,
        },
        {
            accessorKey: 'is_default',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: t('DEFAULT_FOR_MARKET') })),
            cell: ({ row }) => booleanFormatter(row.original.is_default),
            size: 160,
        },
        {
            accessorKey: 'numberOfShippers',
            header: ({ column }) => (React.createElement(DataTableColumnHeader, { column: column, title: t('OF_ASSIGNED_SHIPPERS'), className: "justify-end" })),
            cell: ({ row }) => {
                var _a;
                return (React.createElement("div", { className: "text-right" }, (_a = row.original.numberOfShippers) !== null && _a !== void 0 ? _a : 0));
            },
            size: 160,
        },
    ];
}
